import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "./style.scss";
import { ToastContainer, toast } from "react-toastify";

const Profile = () => {
    const [user, setUser] = useState({});
    const [newPassword, setNewPassword] = useState('');
    const [newEmail, setNewEmail] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const [subscriptionStatus, setSubscriptionStatus] = useState('');

    const navigate = useNavigate ();


    useEffect(() => {
        const fetchProfileData = async () => {
            const token = localStorage.getItem('authToken');

            try {
                const response = await fetch('https://www.calmestcrypto.com/stripe/profile', {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                const data = await response.json();
                console.log ("data", data);

                if (data && data.user) {
                    setUser(data.user);
                    setSubscriptionStatus(data.user.status);
                } else {
                    navigate ("/premium");
                }
            } catch (error) {
                console.log("Error fetching profile data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchProfileData();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    const handleCancelSubscription = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch('https://www.calmestcrypto.com/stripe/cancelSubscription', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.status !== 200) {
                throw new Error('Failed to cancel subscription');
            }

            toast.success ('Subscription canceled');
            setSubscriptionStatus('canceled');

        } catch (err) {
            setError(err.message);
        }
    };

    const handleReactivateSubscription = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch('https://www.calmestcrypto.com/stripe/reactivateSubscription', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
    
            const data = await response.json();
    
            if (response.status !== 200) {
                throw new Error(data.message || 'Failed to reactivate subscription');
            }
    
            toast.success ('Subscription reactivated');
            setSubscriptionStatus(data.status);
    
        } catch (err) {
            setError(err.message);
        }
    };
    

    const handleChangePassword = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch('https://www.calmestcrypto.com/stripe/changePassword', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ newPassword })
            });
    
            const data = await response.json();
    
            if (response.status !== 200) {
                throw new Error(data.message || 'Failed to change password');
            }
    
            if (data.token) {
                // Update token in case backend provides a new one after password change
                localStorage.setItem('authToken', data.token);
            }
    
            toast.success ('Password changed successfully');
        } catch (err) {
            setError(err.message);
        }
    }
    ;

    const handleChangeEmail = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch('https://www.calmestcrypto.com/stripe/changeEmail', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ newEmail })
            });

            if (response.status !== 200) {
                throw new Error('Failed to change email');
            }

            toast.success ('Email changed successfully');
        } catch (err) {
            setError(err.message);
        }
    };

    const handleUpdatePayment = async () => {
        try {
            const token = localStorage.getItem('authToken');
            console.log ("user.stripeCustomerId", user.stripeCustomerId);
            const response = await fetch('https://www.calmestcrypto.com/stripe/create-customer-portal-session', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ stripeCustomerId: user.stripeCustomerId }) 
            });

            const data = await response.json();

            if (response.status !== 200) {
                throw new Error(data.message || 'Failed to open Customer Portal');
            }

            window.location.href = data.url;
        } catch (err) {
            setError(err.message);
        }
    };

    

    return (
        <div className="profile-container">
            <h2>Your Account</h2>
            <div>Email: {user.email}</div>
            <div>Username: {user.username}</div>
            <div>Start Date: {new Date(user.startDate).toLocaleDateString()}</div>
            <div>Subscription End Date: {new Date(user.endDate).toLocaleDateString()}</div>
            <div>Status: {subscriptionStatus}</div>

            {error && <div className="error-message">{error}</div>}

            <button onClick={handleUpdatePayment}>Manage Subscription</button>

            {subscriptionStatus === 'canceled' ? <button onClick={handleReactivateSubscription}>Reactivate Subscription</button> : ""}


            <div className="change-password-section">
                <h3>Change Password</h3>
                <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} />
                <button onClick={handleChangePassword}>Change Password</button>
            </div>

            <div className="change-email-section">
                <h3>Change Email</h3>
                <input type="email" value={newEmail} onChange={e => setNewEmail(e.target.value)} />
                <button onClick={handleChangeEmail}>Change Email</button>
            </div>

            <h3 onClick={() => navigate ("/premium")}>Return to Dream Girls Generator</h3>
        </div>
    );
};

export default Profile;
